import { MenuItemProps } from "../types";
import { useMenu } from "utilities/MenuProvider";
import MenuBaseItem from "./MenuBaseItem";
import MenuGroupItem from "./MenuGroupItem";
import MenuListItem from "./MenuListItem";
import MenuTopItem from "./MenuTopItem";
import React, { useState } from "react";
import cn from "classnames";

const MenuItem = ({ data, currentLevel = 0 }: MenuItemProps) => {
  const { pageReference, customClass } = data;
  const menuHelpers = useMenu();
  const { nextMenuMobile, currentPageParentSlug } = menuHelpers;

  let classItem = "";
  let ComponentItem: React.ReactNode = null;
  let labelNavBreadcrumb = "";
  let classChild = "";
  let otherProps = {};
  let menuNavName = "";
  let hasSubmenu = false;

  const [openSubmenuBaseItem, setOpenSubmenuBaseItem] = useState(false);
  // NOTE: for drow submenu when over state set false
  const [drowMenu, setDrowMenu] = useState(true);
  const triggerOpenSubmenuBaseItem = () => {
    setOpenSubmenuBaseItem(true);
  };

  // NOTE: for drow submenu when over state decomment use effect
  // useEffect(() => {
  //   if (openSubmenuBaseItem) {
  //     setDrowMenu(true);
  //   }
  // }, [openSubmenuBaseItem]);

  const { __typename: typename } = data;

  switch (typename) {
    case "ContentfulMenuTopItemV2":
      labelNavBreadcrumb = data.pageReference.content[0].label;
      menuNavName = "MenuTopItem";

      // CHECK ACTIVE ITEM MENU TOP
      // TODO: gestire eventuale menu forzato
      if (pageReference.internalLink) {
        if (pageReference.internalLink.slug === currentPageParentSlug) {
          classChild = "menuNav--open";
          classItem = `menuItem-${menuNavName}--open`;
        }
      }

      ComponentItem = (
        <MenuTopItem
          data={data}
          currentLevel={currentLevel}
          className={classChild}
        />
      );
      break;
    case "ContentfulMenuBaseItemV2":
      menuNavName = "MenuBaseItem";
      classItem =
        data.content && data.content.length > 0 ? "menuNav__submenu" : "";
      labelNavBreadcrumb = data.pageReference.content[0].label;
      otherProps = {
        onMouseOver: triggerOpenSubmenuBaseItem,
      };
      hasSubmenu = !!(data.content && data.content.length > 0);

      ComponentItem = (
        <MenuBaseItem
          data={data}
          currentLevel={currentLevel}
          // className={classChild}
          nextMenuMobile={nextMenuMobile}
          hasSubmenu={hasSubmenu}
          drowSubmenu={drowMenu}
        />
      );
      break;
    case "ContentfulMenuGroupItemV2":
      menuNavName = "MenuGroupItem";

      if (data.pageReference !== null) {
        labelNavBreadcrumb = data.pageReference.content[0].label;
      } else if (data.label !== null && data.label !== "") {
        labelNavBreadcrumb = data.label;
      } else {
        classItem = "menuItem__skip";
      }
      hasSubmenu = !!(data.content && data.content.length > 0);

      ComponentItem = (
        <MenuGroupItem
          data={data}
          currentLevel={currentLevel}
          className={classChild}
          nextMenuMobile={nextMenuMobile}
          hasSubmenu={hasSubmenu}
        />
      );
      break;
    case "ContentfulMenuListItemV2":
      menuNavName = "MenuListItem";
      ComponentItem = <MenuListItem data={data} />;

      break;
    default:
      return null;
  }

  const menuItemClass = cn(
    "menuItem",
    {
      "menuItem--has-submenu": hasSubmenu,
      [`menuItem-level-${currentLevel}`]: true,
      [`menuItem-${menuNavName}`]: true,
    },
    classItem,
    customClass,
  );

  return (
    <li
      className={menuItemClass}
      data-level={currentLevel}
      data-label_breadcrumb={labelNavBreadcrumb}
      {...otherProps}
    >
      {ComponentItem}
    </li>
  );
};

export default MenuItem;
